<nts-loader [isVisible]="masterViewModel.actionInProgress$ | async"></nts-loader>
<div class="aside-left-control-top-content">
    <div class="search-container">
        <nts-text-button [icon]="'search'" (onClicked)="masterViewModel.search.execSearch(masterViewModel.search.value)"></nts-text-button>
        <nts-search-text-box [propertyViewModel]="masterViewModel.search" placeholder="Search">
        </nts-search-text-box>
    </div>
</div>
<div class="aside-left-control-bottom-content">
    <div class="filter-pane-content">

        <div *ngIf="masterViewModel.showExtendedFilter">

            <div class="caption-panel">
                <nts-label-box label="Filtra ricerca per:"></nts-label-box>
            </div>
            <div class="">
                <div class="filter-lines-container">
                    <div *ngFor="let filter of masterViewModel.extendedFiltersList"
                        class="advanced-list-filter-line">
                        <div class="header">
                            
                            <div class="caption-container">
                                <nts-label-box [label]="filter.codeProperty
                                    ? filter.codeProperty.metadataDescription :
                                    filter.property.metadataDescription"></nts-label-box>
                            </div>

                        </div>

                        <nts-string-text-box *ngIf="isString(filter.property)" [multiline]="false"
                            [propertyViewModel]="filter.property" [updateOnBlur]="false">
                        </nts-string-text-box>

                        <nts-numeric-text-box *ngIf="isNumeric(filter.property)"
                            [propertyViewModel]="filter.property" [updateOnBlur]="false">
                        </nts-numeric-text-box>

                        <nts-enum-text-box [appendTo]="'body'" *ngIf="isEnum(filter.property)"
                            [propertyViewModel]="filter.property">
                        </nts-enum-text-box>

                        <nts-toggle-text-box *ngIf="isBool(filter.property)"
                            [propertyViewModel]="filter.property">
                        </nts-toggle-text-box>

                        <nts-date-text-box *ngIf="isDate(filter.property)"
                            [propertyViewModel]="filter.property">
                        </nts-date-text-box>

                        <nts-date-offset-text-box *ngIf="isDateTimeOffset(filter.property)"
                            [propertyViewModel]="filter.property">
                        </nts-date-offset-text-box>

                        <nts-enum-text-box *ngIf="isOffset(filter.property)"
                            [propertyViewModel]="filter.property">
                        </nts-enum-text-box>

                        <nts-ext-new-autocomplete-text-box [appendTo]="'body'"
                            *ngIf="isExternal(filter.property)"
                            [showCodeInDescription]="filter.showCode"
                            [externalPropertyViewModel]="filter.property"
                            [propertyViewModel]="filter.codeProperty" [updateOnBlur]="true">
                        </nts-ext-new-autocomplete-text-box>

                    </div>
                </div>
            </div>
        </div>

        <nts-grid class="full-column" (rowDoubleClick)="selectRow()" (keydown.enter)="selectRow()"
            (onGridOptionsReady)="onGridOptionsReady($event)"
            [showErrorsInCells]="false" [collectionViewModel]="masterViewModel.searchResult" [isDisabled]="true"
            [autoCreateRow]="false" [minRowNumberHeight]="0" [pagination]="true" [defaultCommandsName]="[]"
            [columns]="masterViewModel.searchResultColumns" (onColumnsChanged)="masterViewModel.onSearchColumnsChanged($event)"
            [customViewCommandsName]="['toggleExtendedFilterCommand']">
        </nts-grid>

    </div>
</div>
